import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { disputesApi } from '../api';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { MessageSquare, Loader2, ChevronRight } from 'lucide-react';

const formatDate = (date) => new Date(date).toLocaleDateString('en-NG', { year: 'numeric', month: 'short', day: 'numeric' });

export default function DisputesPage() {
  const [disputes, setDisputes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { fetchDisputes(); }, []);

  const fetchDisputes = async () => {
    try { const response = await disputesApi.getAll(); setDisputes(response.data); } 
    catch (error) { console.error('Failed to fetch disputes:', error); } 
    finally { setIsLoading(false); }
  };

  if (isLoading) return <div className="flex justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-[#FFD700]" /></div>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white font-['Outfit']">My Disputes</h1>
      {disputes.length === 0 ? (
        <div className="text-center py-12"><MessageSquare className="w-16 h-16 mx-auto text-zinc-600 mb-4" /><p className="text-zinc-400">No disputes</p></div>
      ) : (
        <div className="space-y-4">
          {disputes.map((dispute) => (
            <Link key={dispute.id} to={`/disputes/${dispute.id}`}>
              <Card className="bg-[#0A0A0A] border-white/10 hover:border-[#FFD700]/30 transition-colors">
                <CardContent className="p-4 flex items-center justify-between">
                  <div><p className="font-semibold text-white">{dispute.title}</p><p className="text-sm text-zinc-500">{formatDate(dispute.created_at)} · Order #{dispute.order_id.slice(0, 8)}</p></div>
                  <div className="flex items-center gap-4">
                    <Badge variant="outline" className={dispute.status === 'resolved' ? 'border-green-500/30 text-green-500' : dispute.status === 'closed' ? 'border-zinc-500/30 text-zinc-500' : 'border-yellow-500/30 text-yellow-500'}>{dispute.status}</Badge>
                    <ChevronRight className="w-5 h-5 text-zinc-500" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
